import { fetcher } from '@commenda/utils';

/** Exactly one identifier. An address with no account yet gets one, so the admin app only needs the email. */
export type SeedAmTpDemoBody =
  | { targetUserId: string }
  | { targetUserEmail: string; targetUserName?: string; firmName?: string };

export interface SeedAmTpDemoResponse {
  amTpDemo: {
    affiliateFirmId: string;
    anchorCompanyId: number;
    /** True when the account already carried the demo firm, so nothing was written. */
    wasAlreadySeeded: boolean;
  };
}

/**
 * Writes the transfer pricing demo's opening state for a demo account.
 *
 * Its own route rather than an option on the demo-setup endpoint, because the whole route is gated on the demo
 * feature flag and mounting it beside the other presets would take them down whenever the flag is off.
 */
export async function seedAmTpDemo(
  body: SeedAmTpDemoBody
): Promise<SeedAmTpDemoResponse> {
  const response = await fetcher('demo/am-tp-demo/seed', {
    method: 'POST',
    body,
  });

  if (!response.ok) {
    // The API explains the refusal — an account in another firm, or one that does not exist —
    // and that sentence is the whole answer for the caller, so it is not swallowed here.
    const body = (await response.json().catch(() => null)) as {
      message?: string;
    } | null;

    throw new Error(
      body?.message ?? 'Failed to seed the transfer pricing demo'
    );
  }

  return response.json() as Promise<SeedAmTpDemoResponse>;
}
